var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    id: "svg3",
    sodipodiDocname: "world.svg",
    inkscapeVersion: "1.4 (86a8ad7, 2024-10-11)",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview3",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapeShowpageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1",
    inkscapeZoom: 17.228571,
    inkscapeCx: 16.426202,
    inkscapeCy: 17.616086,
    "inkscapeWindow-width": 1440,
    "inkscapeWindow-height": 847,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    "inkscapeCurrent-layer": "svg3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 18.415,35 C 15.9942,35 13.7192,34.5406 11.59,33.6219 9.46087,32.7031 7.60879,31.4563 6.03379,29.8813 4.45879,28.3063 3.21191,26.4542 2.29316,24.325 1.37441,22.1958 0.915039,19.9208 0.915039,17.5 c 0,-2.4208 0.459371,-4.6958 1.378121,-6.825 C 3.21191,8.54583 4.45879,6.69375 6.03379,5.11875 7.60879,3.54375 9.46087,2.29688 11.59,1.37813 13.7192,0.459375 15.9942,0 18.415,0 c 2.4209,0 4.6959,0.459375 6.825,1.37813 2.1292,0.91875 3.9813,2.16562 5.5563,3.74062 1.575,1.575 2.8219,3.42708 3.7406,5.55625 0.9188,2.1292 1.3781,4.4042 1.3781,6.825 0,2.4208 -0.4593,4.6958 -1.3781,6.825 -0.9187,2.1292 -2.1656,3.9813 -3.7406,5.5563 -1.575,1.575 -3.4271,2.8218 -5.5563,3.7406 C 23.1109,34.5406 20.8359,35 18.415,35 Z m -1.75,-3.5875 V 28 C 15.7025,28 14.8786,27.6573 14.1932,26.9719 13.5077,26.2865 13.165,25.4625 13.165,24.5 V 22.75 L 4.76504,14.35 C 4.67754,14.875 4.59733,15.4 4.52441,15.925 4.4515,16.45 4.41504,16.975 4.41504,17.5 c 0,3.5292 1.15937,6.6208 3.47812,9.275 2.31874,2.6542 5.24274,4.2 8.77184,4.6375 z M 28.74,26.95 c 0.5834,-0.6417 1.1084,-1.3344 1.575,-2.0781 0.4667,-0.7438 0.8532,-1.5167 1.1594,-2.3188 0.3063,-0.8021 0.5396,-1.626 0.7,-2.4718 0.1604,-0.8459 0.2406,-1.7063 0.2406,-2.5813 0,-2.8583 -0.7948,-5.4688 -2.3843,-7.83125 C 28.4411,7.30625 26.3192,5.6 23.665,4.55 v 0.7 c 0,0.9625 -0.3427,1.78646 -1.0281,2.47187 C 21.9515,8.40729 21.1275,8.75 20.165,8.75 h -3.5 v 3.5 c 0,0.4958 -0.1677,0.9115 -0.5031,1.2469 C 15.8265,13.8323 15.4109,14 14.915,14 h -3.5 v 3.5 h 10.5 c 0.4959,0 0.9115,0.1677 1.2469,0.5031 0.3354,0.3354 0.5031,0.7511 0.5031,1.2469 v 5.25 h 1.75 c 0.7584,0 1.4438,0.226 2.0563,0.6781 0.6125,0.4521 1.0354,1.0427 1.2687,1.7719 z",
    fill: "url(#paint0_linear_842_5845)",
    id: "path2",
    style: {}
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_842_5845",
    x1: 0.280021,
    y1: 18.2342,
    x2: 36.4855,
    y2: 18.2342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6430E6",
    id: "stop2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#895EF6",
    id: "stop3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.ed027680944dac6f7a85d2a2f67eb7b7.svg";
export { ForwardRef as ReactComponent };